module.exports = __webpack_public_path__ + "media/dangerous_goods_woodpacking_notification_en.f49ede6a.mp3";